import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import 'rsuite/DateRangePicker/styles/index.css';

interface IDateRangePickerInput {
  showDefaultDate?: boolean;
  resetYear?: string[];
  setResetYear?: React.Dispatch<React.SetStateAction<string[]>>;
  dateChangeHandler: (date: Date[]) => void;
}

const DateRangePickerInput = ({
  showDefaultDate,
  setResetYear,
  dateChangeHandler,
}: IDateRangePickerInput) => {
  return (
    <div>
      <DateRangePicker
        size="md"
        format="dd/MM/yyyy"
        placeholder="From - To"
        placement="auto"
        defaultValue={
          showDefaultDate
            ? [
                moment().startOf('month').toDate(),
                moment().endOf('month').toDate(),
              ]
            : null
        }
        // value={
        //   resetYear && resetYear.length === 2
        //     ? [new Date(resetYear[0]), new Date(resetYear[1])]
        //     : null
        // }
        onChange={(value) => {
          if (value && value.length === 2) {
            setResetYear?.([value[0].toString(), value[1].toString()]);
          } else {
            setResetYear?.([]);
          }
          dateChangeHandler(value ?? []);
        }}
        // shouldDisableDate={(date) => date && date.getDay() === 0}
      />
    </div>
  );
};

export default DateRangePickerInput;
